import styled from 'styled-components';

import { media } from '../../utils/mediaQueries';

export const NotificationWrapper = styled.div<{ $fullWidth?: boolean; $transparent?: boolean }>`
    display: flex;
    flex-direction: column;
    border-radius: 6px;
    overflow: hidden;
    /* $transparent → wtapiamy listę w stronę (centrum powiadomień): brak białego tła. */
    background: ${({ theme, $transparent }) => ($transparent ? 'transparent' : theme.colors.card.background)};
    min-width: ${({ $fullWidth }) => ($fullWidth ? '100%' : '300px')};
    max-width: ${({ $fullWidth }) => ($fullWidth ? '100%' : '360px')};
    width: ${({ $fullWidth }) => ($fullWidth ? '100%' : 'auto')};

    ${media.mobile} {
        min-width: ${({ $fullWidth }) => ($fullWidth ? '100%' : '280px')};
        max-width: ${({ $fullWidth }) => ($fullWidth ? '100%' : 'calc(100vw - 32px)')};
    }
`;

export const NotificationHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 14px;
    border-bottom: 1px solid ${({ theme }) => theme.colors.border.primary};
    font-size: 13px;
    font-weight: 300;
    color: ${({ theme }) => theme.colors.text.primary};
`;

/* Monit o zgodę na powiadomienia. Siedzi w dzwonku, a nie w oknie modalnym przy
   logowaniu: zgody pytamy TAM, gdzie użytkownik sam przyszedł po powiadomienia —
   odruchowe „Blokuj" przy wejściu wycisza domenę na stałe, bez drogi powrotnej. */
export const PermissionPrompt = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    margin: 0 12px 8px;
    padding: 10px 12px;
    border: 1px solid ${({ theme }) => theme.colors.border.primary};
    border-radius: 10px;
    font-size: 12px;
    line-height: 1.45;
    color: ${({ theme }) => theme.colors.text.secondary};
`;

export const PermissionButton = styled.button`
    flex-shrink: 0;
    height: 26px;
    padding: 0 12px;
    border: none;
    border-radius: 999px;
    background: #111827;
    color: #fff;
    font-size: 12px;
    font-weight: 500;
    cursor: pointer;

    &:hover {
        background: #000;
    }
`;

export const NotificationList = styled.div`
    display: flex;
    flex-direction: column;
`;

export const NotificationItem = styled.div<{ $isRead?: boolean; $transparent?: boolean }>`
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 8px 14px 8px 18px;
    border-bottom: 1px solid ${({ theme }) => theme.colors.border.primary};
    cursor: pointer;
    transition: background 0.15s ease;
    position: relative;
    background: ${(props) => {
    // Przeczytane: bez białego tła gdy $transparent (wtapiamy w stronę),
    // nieprzeczytane zachowują subtelny akcent koloru.
    if (props.$isRead) return props.$transparent ? 'transparent' : props.theme.colors.card.background;
    return props.theme.mode === 'dark' ? 'rgba(26, 77, 77, 0.08)' : 'rgba(26, 77, 77, 0.04)';
  }};

    &:hover {
        background: ${({ theme }) => (theme.mode === 'dark' ? 'rgba(26, 77, 77, 0.12)' : 'rgba(26, 77, 77, 0.08)')};
    }

    &:last-child {
        border-bottom: none;
    }

    ${media.mobile} {
        padding: 8px 12px 8px 16px;
        gap: 0;
    }
`;

export const UnreadBadge = styled.div`
    position: absolute;
    left: 7px;
    top: 13px;
    width: 6px;
    height: 6px;
    background: #E07B2D;
    border-radius: 50%;
    box-shadow: 0 0 0 2px ${({ theme }) => theme.colors.card.background};
`;

export const IconWrapper = styled.div<{ color: string }>`
    width: 28px;
    height: 28px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${(props) => props.color};
    flex-shrink: 0;

    ${media.mobile} {
        display: none;
    }
`;

export const NotificationContent = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
`;

export const NotificationTitle = styled.div<{ $transparent?: boolean }>`
    font-size: 12.5px;
    font-weight: 300;
    color: ${({ theme, $transparent }) => ($transparent ? '#111111' : theme.colors.text.primary)};
    line-height: 1.35;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
`;

export const RoomNumber = styled.span`
    color: ${({ theme }) => theme.colors.text.secondary};
    font-weight: 500;
    margin-left: 4px;
`;

/* Odbiór osobisty — ta sama żółta plakietka co w tabeli zamówień. W samym dymku
   systemowym stylowania nie ma (push to czysty tekst), więc tam zostaje znacznik
   „[TAKE TO ROOM]"; tutaj rysujemy listę sami, więc może być kolor. */
export const PickupTag = styled.span`
    display: inline-flex;
    align-items: center;
    margin-left: 6px;
    padding: 0 6px;
    border-radius: 999px;
    background: #fdf766;
    color: #000000;
    font-size: 10px;
    font-weight: 600;
    line-height: 15px;
    white-space: nowrap;
`;

export const NotificationDescription = styled.div<{ $transparent?: boolean }>`
    font-size: 11.5px;
    font-weight: 400;
    color: ${({ theme, $transparent }) => ($transparent ? '#111111' : theme.colors.text.secondary)};
    line-height: 1.4;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
`;

export const NotificationTime = styled.div<{ $transparent?: boolean }>`
    font-size: 10.5px;
    font-weight: 500;
    color: ${({ theme, $transparent }) => ($transparent ? '#4b4b4b' : theme.colors.text.muted)};
    margin-top: 2px;
`;

// Przycisk „Załaduj więcej" pod listą (centrum powiadomień) — doczytuje kolejne 10.
export const LoadMoreRow = styled.div`
    display: flex;
    justify-content: flex-start;
    padding: 16px 0 4px;
`;

export const LoadMoreButton = styled.button`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 8px 18px;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 500;
    color: ${({ theme }) => (theme.mode === 'dark' ? '#e5e7eb' : '#111827')};
    background: ${({ theme }) => (theme.mode === 'dark' ? 'rgba(255, 255, 255, 0.04)' : '#ffffff')};
    border: 1px solid ${({ theme }) => theme.colors.border.primary};
    cursor: pointer;
    transition: all 0.15s ease;

    &:hover:not(:disabled) {
        border-color: ${({ theme }) => (theme.mode === 'dark' ? '#4b5563' : '#d1d5db')};
        background: ${({ theme }) => (theme.mode === 'dark' ? 'rgba(255, 255, 255, 0.06)' : '#f9fafb')};
    }

    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }
`;

export const NotificationEmptyContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 28px 20px;
  text-align: center;

  /* Wewnątrz empty wcięcia NotificationTitle / NotificationDescription
     układają się w kolumnie pod sobą. Te komponenty domyślnie mają
     \`display: flex\` co psuje center alignment — wymuszamy block. */
  & > div {
    display: block;
    text-align: center;
    width: 100%;
  }
`;

/* ── Footer: ghost (lewy) + primary CTA (prawy) ─────────────────────
   Lewy „Oznacz wszystkie" — neutralny tekstowy button (ikonka Check,
   szare letterspacing, hover delikatnie ciemnieje).
   Prawy „Zobacz wszystkie" — pełny primary button z badge'em ilości
   i strzałką, hover rozjaśnia tło. Wyraźna hierarchia: prawy wyciąga
   oko, lewy jest opcjonalny. */
export const NotificationFooter = styled.div`
  padding: 10px 12px;
  border-top: 1px solid ${({ theme }) => theme.colors.border.primary};
  background: ${({ theme }) => theme.colors.card.background};
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

export const FooterGhostButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 6px 8px;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: ${({ theme }) => theme.colors.text.secondary};
  font-size: 11.5px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
  white-space: nowrap;

  svg {
    width: 12px;
    height: 12px;
    flex-shrink: 0;
  }

  &:hover:not(:disabled) {
    background: ${({ theme }) => (theme.mode === 'dark' ? 'rgba(255, 255, 255, 0.04)' : 'rgba(15, 23, 42, 0.04)')};
    color: ${({ theme }) => theme.colors.text.primary};
  }

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
`;

// Prosty, mały czarny button „Pokaż wszystkie" (bez strzałki i licznika).
export const FooterButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  padding: 5px 12px;
  border: 1px solid transparent;
  border-radius: 8px;
  background: #111827;
  color: #ffffff;
  font-size: 11.5px;
  font-weight: 400;
  cursor: pointer;
  transition: background 0.15s ease;
  white-space: nowrap;

  &:hover {
    background: #000000;
  }

  ${({ theme }) => (theme.mode === 'dark'
    ? `
    background: #1f2937;
    border-color: #374151;

    &:hover { background: #111827; }
  `
    : '')}
`;

export const FooterBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 16px;
  padding: 0 5px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.18);
  color: #ffffff;
  font-size: 10.5px;
  font-weight: 400;
`;
